var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.75436V0L7.5 6.33914L15 12.6783V7.92393C21.2063 7.92393 26.25 12.187 26.25 17.4326C26.25 22.1395 22.1812 26.038 16.875 26.7987V30C24.2812 29.2235 30 23.8986 30 17.4326C30 10.4279 23.2875 4.75436 15 4.75436Z",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17.4326C3.75 14.8178 5.00625 12.4406 7.05 10.7132L4.3875 8.46276C1.6875 10.7607 0 13.9303 0 17.4326C0 23.8986 5.71875 29.2235 13.125 30V26.7987C7.81875 26.038 3.75 22.1395 3.75 17.4326Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerate);
export default __webpack_public_path__ + "static/media/regenerate.efba8e67038f31be0a5fc6ba4a6dd313.svg";
export { ForwardRef as ReactComponent };